import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { QuoteEmailTemplate, SiteCode } from '@snap-types/models/enums';
import { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import { UpdateTeamWithConfig } from '@snap-types/models/team';
import { usePreviewQuoteEmailMutation } from '@ui/endpoints/preview-quote-email';
import { useFormContext } from 'react-hook-form';

export function PreviewQuoteEmailButton({
  team,
  index,
}: {
  team: UpdateTeamWithConfig;
  index: number;
}) {
  const form = useFormContext<SnapSiteConfigEditFormDataUnvalidated>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [previewQuoteEmail, { data, isLoading, isError }] =
    usePreviewQuoteEmailMutation();

  const handleOpen = () => {
    const siteCode = form.getValues('site.code') as SiteCode;
    const quoteEmailTemplate = form.getValues(
      `site.teams.${index}.currentTeamConfig.quoteEmailTemplate`,
    ) as QuoteEmailTemplate;

    onOpen();
    void previewQuoteEmail({ siteCode, quoteEmailTemplate });
  };

  return (
    <>
      <Button
        id={`${team.teamCode}-emailTemplate-preview`}
        size="sm"
        onClick={handleOpen}
      >
        Preview
      </Button>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="4xl"
        scrollBehavior="inside"
      >
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>Quote Email Preview — {team.teamCode}</ModalHeader>
          <ModalCloseButton />

          <ModalBody pb={6}>
            {isLoading && <Spinner />}

            {isError && (
              <Text color="red.500">Failed to render the email preview.</Text>
            )}

            {data && (
              <Tabs>
                <TabList>
                  <Tab>HTML</Tab>
                  <Tab>Text</Tab>
                </TabList>

                <TabPanels>
                  <TabPanel px={0}>
                    <Text fontWeight="bold" mb={2}>
                      Subject: {data.subject}
                    </Text>
                    <Box
                      as="iframe"
                      title="Quote email HTML preview"
                      srcDoc={data.html}
                      sandbox=""
                      width="100%"
                      height="500px"
                      border="1px solid"
                      borderColor="gray.200"
                      borderRadius="md"
                    />
                  </TabPanel>
                  <TabPanel px={0}>
                    <Text fontWeight="bold" mb={2}>
                      Subject: {data.subject}
                    </Text>
                    <Box
                      as="pre"
                      whiteSpace="pre-wrap"
                      fontFamily="mono"
                      fontSize="sm"
                      border="1px solid"
                      borderColor="gray.200"
                      borderRadius="md"
                      p={4}
                    >
                      {data.text}
                    </Box>
                  </TabPanel>
                </TabPanels>
              </Tabs>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
